import React, { useEffect, useMemo, useState } from 'react';
import ReactQuill from 'react-quill';
import "react-quill/dist/quill.snow.css";
import TurndownService from 'turndown';
import { useReadMemory } from '../generic/hooks/useReadMemory';
import MemoryType from '../../service/memory/enum/MemoryType';
import "./richsnippetwriter.css"
import { marked } from 'marked';

const RichSnippetWriter = ({ onStrapiDataChange, resetKey, content }) => {
  const [html, setHtml] = useState(content ? marked(content) : "");
  const userJson = useReadMemory(MemoryType.USER);
  const turndownService = useMemo(() => new TurndownService({ headingStyle: "atx" }), []);
  const [strapiData, setStrapiData] = useState({});

  const modules = useMemo(
    () => ({
      toolbar: {
        container: [
          [{ header: [1, 2, 3, 4, 5, 6, false] }],
          ["bold", "italic", "underline", "strike"],
          [{ list: "ordered" }, { list: "bullet" }],
          ["link"],
        ],
      },
    }),
    []
  );

  useEffect(() => {
    const markdown = turndownService.turndown(html);
    const newData = {
      body: markdown,
      author: `${userJson?.givenName} ${userJson?.familyName}`,
      userIdentifier: userJson?.userIdentifier,
    };

    // Check if the data has changed before updating the state
    if (JSON.stringify(newData) !== JSON.stringify(strapiData)) {
      setStrapiData(newData);

      // Invoke the callback to send data to the parent
      onStrapiDataChange(newData);
    }
  }, [html, onStrapiDataChange, turndownService, userJson, strapiData]);

  useEffect(() => {
    const adjustTooltipPosition = () => {
        const tooltip = document.querySelector('.ql-tooltip');
        if (tooltip) {
            const left = parseFloat(tooltip.style.left) || 0;
            if (left < 0) {
                tooltip.style.left = '10px';
            }
        }
    };
    
    const observer = new MutationObserver(adjustTooltipPosition);
    const editorContainer = document.querySelector('.ql-container');
    
    if (editorContainer) {
        observer.observe(editorContainer, {
            childList: true,
            subtree: true,
            attributes: true,
        });
    }
    
    return () => {
        observer.disconnect();
    };
    }, []);

  return (
    <>
      <div className="body-text-section">
        <label htmlFor="details" className='required-mark-label'>Details</label>
        <ReactQuill
          key={resetKey}
          theme="snow"
          value={html}
          onChange={(content) => {
            setHtml(content);
          }}
          style={{ maxHeight: "200px", height: "200px" }}
          modules={modules}
          placeholder="Write your thought here!!!"
        />
      </div>
    </>
  );
};

export default RichSnippetWriter;